import { render } from "./DefinitionOfConsequenceById.vue?vue&type=template&id=32abc3e2&scoped=true"
import script from "./DefinitionOfConsequenceById.vue?vue&type=script&lang=js"
export * from "./DefinitionOfConsequenceById.vue?vue&type=script&lang=js"

import "./DefinitionOfConsequenceById.vue?vue&type=style&index=0&id=32abc3e2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32abc3e2"]])

export default __exports__